import * as React from 'react';

import { InfoBox } from 'common--design-library';

interface ITicketErrorsProps {
    errors?: string[];
    removeMargins?: boolean;
}

export const TicketErrors: React.FC<ITicketErrorsProps> = (props) => {
    return props.errors?.length > 0 &&
        <InfoBox type='error' messages={props.errors.map(error => {
            return {
                text: error,
                withIcon: true
            }
        })}
            removeMargins={props.removeMargins}
            roleForTest="ticket-errors"
        />

}